// import { initializeApp } from "firebase/app";
// import { getDatabase } from "firebase/database";

// const firebaseConfig = {
//     apiKey: "AIzaSyCQX6yuyfNDmyybvVDpFarPamyJ8hTfJBI",
//     authDomain: "hi-blinds-contador.firebaseapp.com",
//     databaseURL: "https://hi-blinds-contador-default-rtdb.firebaseio.com",
//     projectId: "hi-blinds-contador",
//     storageBucket: "hi-blinds-contador.firebasestorage.app",
//     messagingSenderId: "318979042064",
//     appId: "1:318979042064:web:9885614160bb8b1a4e9395"
//   };

// const app = initializeApp(firebaseConfig);
// const database = getDatabase(app);

// export default database;

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBDyHsMULxxa71Ti9roXvuOQP_ds8m5WeY",
  authDomain: "gestion-inventario-hiblinds.firebaseapp.com",
  projectId: "gestion-inventario-hiblinds",
  storageBucket: "gestion-inventario-hiblinds.firebasestorage.app",
  messagingSenderId: "863432973781",
  appId: "1:863432973781:web:aede367de0ddc1f144f15c",
  measurementId: "G-TPEGKRQV4T"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);